import { useState, useEffect, useRef } from "react";
import { TableWidget } from "../../osoigonext_core/Components/Table.jsx";
import FolderNavigationNav from "./FolderNavigationNav.jsx";

export function FileList({ configuration }) {
  const [rootFolder, setRootFolder] = useState(null);
  const [currentFolder, setCurrentFolder] = useState(null);

  const headers = {
    "Accept-Language": window.location.pathname.split("/")[1],
  };
  const tableRef = useRef(null); // used to reach datatables api
  let files_endpoint = `${configuration.base_url}file/?format=datatables`;
  if (configuration.category_id)
    files_endpoint = `${files_endpoint}&category=${configuration.category_id}`;
  if (currentFolder) {
    files_endpoint = `${files_endpoint}&folder=${currentFolder.id}`;
  }

  const table_configuration = {
    ajax: {
      url: files_endpoint,
      headers: headers,
    },
    columns: [
      {
        title: configuration.translations.name,
        data: "description",
        name: "name",
        searchable: true,
        render: function (data, type, row) {
          return `<i class="fa-solid fa-file ${row.extension}"></i> <a href="${row.url}" target="_blank">${data}</a>`;
        },
      },
      {
        title: configuration.translations.size,
        data: "size_formatted",
        searchable: false,
        width: "150px",
        render: function (data, type, row) {
          return `(<span class="text-uppercase">${row.extension}</span> ${data})`;
        },
      },
    ],
    active_language: configuration.active_language,
  };

  useEffect(() => {
    getFolders();
  }, []);

  const getFolders = async () => {
    if (configuration.folder_id) {
      const folder_endpoint = `${configuration.base_url}folder/${configuration.folder_id}/recursive/`;
      fetch(folder_endpoint, { headers: headers })
        .then((response) => response.json())
        .then((data) => {
          setRootFolder(data);
          setCurrentFolder(data);

          console.log("DATA FOLDER", data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  if (tableRef.current) {
    // if datatables is already rendered update ajax endpoint
    tableRef.current.dt().ajax.url(files_endpoint).load();
  }

  let foldersOutputNav = "";
  if (rootFolder && configuration.recursive) {
    foldersOutputNav = (
      <FolderNavigationNav
        configuration={configuration}
        setCurrentFolder={setCurrentFolder}
        rootFolder={rootFolder}
        currentFolder={currentFolder}
      ></FolderNavigationNav>
    );
  }

  return (
    <div className="file-list border rounded p-2">
      {foldersOutputNav}     
      <div className="mt-2">
        <div className="border rounded p-2 shadow-sm">
          <TableWidget
            configuration={table_configuration}
            tableRef={tableRef}
          ></TableWidget>
        </div>
      </div>
    </div>
  );
}
